@if (item.externalHref) {
<a
  class="sm-nav-menu-item"
  [attr.title]="item.badgeDescription || item.text"
  [class.sm-nav-menu-item--level-1]="level === 1"
  [class.sm-nav-menu-item--level-2]="level === 2"
  [class.sm-nav-menu-item--selected]="selected"
  [class.sm-nav-menu-item--expanded]="expanded"
  [class.sm-nav-menu-item--disabled]="isDisabled"
  [class.sm-nav-menu-item--has-children]="hasChildren"
  [ngStyle]="getToneStyles(item.tone)"
  [attr.href]="isDisabled ? null : item.externalHref"
  target="_blank"
  rel="noopener noreferrer"
  [attr.aria-label]="item.externalLabel ? item.text + ' — ' + item.externalLabel : null"
  [attr.tabindex]="isDisabled ? -1 : 0"
  [attr.aria-disabled]="isDisabled ? 'true' : null"
  [attr.aria-current]="ariaCurrent"
  [attr.aria-expanded]="hasChildren ? expanded : null"
  (keydown.enter)="handleGroupKeydown($event)"
  (keydown.space)="handleGroupKeydown($event)"
  (click)="handleLinkClick($event)">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>
} @else {
<a
  class="sm-nav-menu-item"
  [attr.title]="item.badgeDescription || item.text"
  [class.sm-nav-menu-item--level-1]="level === 1"
  [class.sm-nav-menu-item--level-2]="level === 2"
  [class.sm-nav-menu-item--selected]="selected"
  [class.sm-nav-menu-item--expanded]="expanded"
  [class.sm-nav-menu-item--disabled]="isDisabled"
  [class.sm-nav-menu-item--has-children]="hasChildren"
  [ngStyle]="getToneStyles(item.tone)"
  [routerLink]="isDisabled ? null : (item.routeHref || item.route || null)"
  [attr.href]="isDisabled ? null : (item.routeHref || null)"
  [attr.aria-label]="item.badgeDescription || null"
  [attr.tabindex]="isDisabled ? -1 : 0"
  [attr.aria-disabled]="isDisabled ? 'true' : null"
  [attr.aria-current]="ariaCurrent"
  [attr.aria-expanded]="hasChildren ? expanded : null"
  (keydown.enter)="handleGroupKeydown($event)"
  (keydown.space)="handleGroupKeydown($event)"
  (click)="handleLinkClick($event)">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>
}
<ng-template #itemContent>
  <span class="sm-nav-menu-item__icon" aria-hidden="true">
    @if (item.iconName) {
      <ion-icon [name]="item.iconName"></ion-icon>
    }
  </span>

  <span class="sm-nav-menu-item__text">{{ item.text }}</span>

  <span class="sm-nav-menu-item__badge" [class.sm-nav-menu-item__badge--hidden]="!item.badgeText">
    {{ item.badgeText || '' }}
  </span>

  <span class="sm-nav-menu-item__chevron" aria-hidden="true">
    @if (hasChildren) {
      <ion-icon [name]="expanded ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
    } @else if (item.externalHref) {
      <ion-icon name="open-outline"></ion-icon>
    }
  </span>
</ng-template>
